export default __webpack_public_path__ + "static/posts-2520b67cbcc8533c007d714220c7efac.png";